'use client';

import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';

import getConfig from './configUtils';

type Config = {
  [key: string]: any;
};

export const ConfigContext = createContext<Config | null>(null);

type ConfigProviderProps = {
  children: ReactNode;
};

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    const fetchConfigData = async () => {
      const configData = await getConfig();
      setConfig(configData);
    };

    fetchConfigData();
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  const config = useContext(ConfigContext);
  return config;
};
